import React from "react";
import { useState } from "react";
import "../../assets/css/faqs.css";
import Faqs from "../../components/Faqs";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Loader } from "../../constant/Index";
import { useFaqsContentQuery } from "../../store/services/FaqService";

const FaqPage = () => {
	const [type, setType] = useState(null)
	const handleClick = (name) => {
		setType(name)
	}
	const { data, isLoading } = useFaqsContentQuery(type);
	let response = data?.response?.data
	return (
		<>
			{/* Header Start Here */}
			<Header />
			{/* Header End Here */}

			{/* <!-- FAQs Sec Start Here --> */}
			<section className="faqs_sec">
				<div className="glowing glowing-one">
					<span></span>
				</div>
				<div className="container">
					<div className="heading-wrapper">
						<div className="glowing glowing-three">
							<span></span>
						</div>
						<h5>FREQUENTLY ASKED QUESTIONS</h5>
						<h2>POPULAR QUESTIONS</h2>
						<p>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
							eiusmod tempor
						</p>
					</div>
					<div className="row">
						<div className="col-lg-2"></div>
						<div className="col-lg-8">
							<nav>
								<div className="nav nav-tabs tab-buttons" id="nav-tab" role="tablist">
									<button onClick={() => handleClick('')} className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">All</button>
									<button onClick={() => handleClick('specific')} className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Specific</button>
									<button onClick={() => handleClick('general')} className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">General</button>
								</div>
							</nav>
							{/* <div className="tab-buttons">
								<button onClick={() => handleClick('')} className="all">All</button>
								<button onClick={() => handleClick('general')} className="general">General</button>
								<button onClick={() => handleClick('specific')} className="Specific">Specific</button>
							</div> */}
							<div className="accordion" id="accordionExample">
								{isLoading ? <><div
									className="loader"
									style={{ margin: "0px auto", textAlign: "center" }}
								>
									<img
										src={Loader}
										style={{ margin: "0px auto" }}
										alt=""
										className="img-fluid"
									/>
								</div></> : <>
									{response?.map((data, index) => {
										return (
											<div
												key={index}
												className="accordion-item wow animate__animated animate__fadeInDown"
											>
												<h2 className="accordion-header" id={"heading" + data?.id}>
													<button
														className="accordion-button"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target={"#collapse" + data?.id}
														aria-expanded="false"
														aria-controls={"collapse" + data?.id}
													>
														<i className="fa fa-plus" aria-hidden="false"></i>
														<h5>{data?.questions}</h5>
													</button>
												</h2>
												<div
													id={"collapse" + data?.id}
													className="accordion-collapse collapse"
													aria-labelledby={"heading" + data?.id}
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<p
															dangerouslySetInnerHTML={{
																__html: data?.answers,
															}}
														></p>
													</div>
												</div>
											</div>
										);
									})}
								</>}
							</div>
						</div>
						<div className="col-lg-2"></div>
					</div>
				</div>
				<div className="glowing glowing-two">
					<span></span>
				</div>
			</section>
			{/* <!-- FAQs Sec End Here --> */}

			{/* Footer Start Here */}
			<Footer />
			{/* Footer End Here */}
		</>
	);
};

export default FaqPage;
